import Vue from 'vue'
import VueRouter from 'vue-router'
import lanhu_frame from '../views/lanhu_frame/index.vue'
import lanhu_frame_1 from '../views/lanhu_frame_1/index.vue'
import ChartFullscreen from '../views/ChartFullscreen.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'audio-viewData',
    component: lanhu_frame
  },
  {
    path: '/index',
    name: 'index',
    component: lanhu_frame
  },
  {
    path: '/details',
    name: 'details',
    component: lanhu_frame_1
  },
  {
    path: '/chart-fullscreen',
    name: 'chart-fullscreen',
    component: ChartFullscreen
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
